// extracted by mini-css-extract-plugin
export default {"feedback_btns":"FeedbackOptions_feedback_btns__AFp8H"};